import React, { useState, useRef } from "react";
import { Button, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import { useChatBotStreamResponse } from "./hooks";
import { useMessageStore } from "./message-store-context";
import ChatBotHeader from "./chatbot-header";
import ChatBotMessages from "./chatbot-messages";
import ChatBotInput from "./chatbot-input";

const ChatBotWindow = ({ config }) => {
  const {
    messages,
    addMessage,
    updateLastAssistantMessage,
    removeLastAssistantMessage,
  } = useMessageStore();
  const [input, setInput] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isStreaming, setIsStreaming] = useState(false);
  const mutationRef = useRef(null);

  const { mutate, isLoading, cancel } = useChatBotStreamResponse(
    config.chatbot_api_url,
    (delta, fullMessage) => {
      updateLastAssistantMessage(fullMessage);
    },
  );

  const handleSendMessage = (input) => {
    if (!input.trim() || isStreaming) return;

    const userMessage = { role: "user", content: input };
    addMessage(userMessage);

    const updatedMessages = [...messages, userMessage];
    setInput("");
    setIsStreaming(true);

    addMessage({ role: "assistant", content: "" });

    mutationRef.current = mutate(updatedMessages, {
      onSuccess: () => {
        setIsStreaming(false);
      },
      onError: () => {
        setIsStreaming(false);
      },
    });
  };

  const handleCancelStream = () => {
    cancel();
    setIsStreaming(false);
  };

  return (
    <div className="chatbot-container">
      {isOpen && (
        <div className="chatbot-window">
          <ChatBotHeader onClose={() => setIsOpen(false)} />
          <div className="chatbot-content">
            <ChatBotMessages isLoading={isLoading || isStreaming} />
            <ChatBotInput
              input={input}
              setInput={setInput}
              handleSend={handleSendMessage}
              handleKeyPress={(e) =>
                e.key === "Enter" && handleSendMessage(input)
              }
              isStreaming={isStreaming}
              handleCancelStream={handleCancelStream}
            />
          </div>
        </div>
      )}
      {!isOpen && (
        <Button
          circular
          icon="leaf"
          className="chatbot-open-button"
          onClick={() => setIsOpen(true)}
          aria-label="Open Leafie"
          size="big"
        />
      )}
    </div>
  );
};

ChatBotWindow.propTypes = {
  config: PropTypes.object,
};

export default ChatBotWindow;
